// extracted by mini-css-extract-plugin
module.exports = {"navButton":"searchPagination_navButton__umbMQ","navIcon":"searchPagination_navIcon__kyK3C"};